import type { HeroAsinWithIntent } from "@/types";

export function formatSigned(value: number | null | undefined): string {
  if (value == null) return "—";
  return value > 0 ? `+${value}` : `${value}`;
}

export function formatSignedPct(value: number | null | undefined): string {
  if (value == null) return "—";
  return value > 0 ? `+${value}%` : `${value}%`;
}

export interface SwitchMarker {
  date: string;
  testName: string;
  productName: string;
  asin: string;
  switchDate: string;
  imageUrl: string;
}

export function buildSwitchMarkers(
  chartData: { date: string }[],
  heroAbTests: HeroAsinWithIntent[],
): SwitchMarker[] {
  const markers: SwitchMarker[] = [];
  for (const hero of heroAbTests) {
    for (const test of hero.tests) {
      if (!test.variantBSwitchDate) continue;
      const switchDate = new Date(test.variantBSwitchDate);
      const dateStr = switchDate.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const matchingDay = chartData.find((d) => d.date === dateStr);
      if (matchingDay) {
        markers.push({
          date: dateStr,
          testName: test.name,
          productName: hero.title.split(" - ")[0],
          asin: hero.asin,
          switchDate: test.variantBSwitchDate,
          imageUrl: hero.imageUrl,
        });
      }
    }
  }
  return markers;
}
